import createAxiosInstance from '../createAxiosInstance';

const ORDER_API_URL = import.meta.env.VITE_API_URL_ORDER;

if (ORDER_API_URL === undefined) {
    throw new Error('Order API URL is not defined');
}

const axios = createAxiosInstance(ORDER_API_URL);

export default axios;
